import _startsWith from 'lodash/startsWith';
import * as types from '../constants/ActionTypes';
import Page from '../../lib/page';
import i18n from '../../lib/reacti18n';

const exp = Page.getUserExperience();
const label = i18n.message(`smarthelp/contentToggle.content.label.desktop.${exp}`);

function setBreadcrumbItems(items) {
  return {
    type: types.UPDATE_BREADCRUMB,
    payload: items,
  };
}
export function updateBreadcrumb(items) {
  return (dispatch) => {
    dispatch(setBreadcrumbItems(items));
  };
}

function validateArticleId(articleID) {
  return _startsWith(articleID, 'FAQ') || _startsWith(articleID, 'faq')
  || _startsWith(articleID, 'TS') || _startsWith(articleID, 'ts');
}

export function updateBreadCrumbFromArticleContent(response) {
  const items = [];
  if (validateArticleId(response.articleId)) {
    if (response.breadCrumbPath && response.breadCrumbTitle) {
      const path = response.breadCrumbPath.split('/');
      const title = response.breadCrumbTitle.split('/');
      if (Page.isMobileLayout()) {
        items.push({
          path: `/topic/${path[0]}`,
          title: title[1],
          id: path[1],
        });
      } else {
        items.push({
          path: '/home',
          title: label,
          id: path[0],
        }, {
          path: `/topic/${path[0]}`,
          title: title[0],
          id: path[0],
        }, {
          path: `/topic/${path[0]}`,
          title: title[1],
          id: path[1],
        });
      }
    }
  }

  return {
    type: types.UPDATE_BREADCRUMB,
    payload: items,
  };
}

export function resetBreadcrumb() {
  return {
    type: types.RESET_BREADCRUMB,
  };
}
